<template>
  <div class="panel">
    <div class="title">创建方案</div>
    <div class="template-list">
      <TemplateCard style="background: white" />
      <TemplateCard
        v-for="item in templateList"
        :key="item.uid"
        :name="item.name"
        :bgImg="item.imgUrl"
        @deleteTemplate="deleteTemplate"
        @reloadTemplate="reloadTemplate"
        :id="item.uid"
      />
    </div>
  </div>
</template>

<script>
import TemplateCard from './components/TemplateCard'
import { getTemplateDto, deleteTemplate } from '../../API/template'
export default {
  components: {
    TemplateCard
  },
  async created () {
    const data = await getTemplateDto()
    this.templateList = data
  },
  data () {
    return {
      templateList: [
      ]
    }
  },
  methods: {
    async reloadTemplate (a, callback) {
      const data = await getTemplateDto()
      this.templateList = data
      callback()
    },
    async deleteTemplate (uid) {
      const res = await deleteTemplate({ templateUid: uid })
      console.log('res', res)
      if (res === '操作成功') {
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      } else {
        this.$message({
          type: 'error',
          message: res
        })
      }
      const data = await getTemplateDto()
      this.templateList = data
    }
  }
}
</script>

<style lang="less" scoped>
.panel {
  .title {
    font-size: 20px;
    color: var(--main-text);
    margin-bottom: 32px;
  }
  .template-list {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
}
</style>
